// This file was autogenerated from /frontend/sail-next/packages/docs/src/component-examples/BarChart/basic.story.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {BarChart} from '@sail/charts';
import {ResizableContainer} from '../common/ResizableContainer';

const sales = [
  {
    date: 'Jan',
    sold: 1,
  },
  {
    date: 'Feb',
    sold: 4,
  },
  {
    date: 'Mar',
    sold: 2,
  },
  {
    date: 'Apr',
    sold: 3,
  },
];
export const Basic = () => {
  return (
    <ResizableContainer minWidth={150} width={500} maxWidth={800}>
      <BarChart data={sales} x="date" y="sold" />
    </ResizableContainer>
  );
};
